import { getAucklandISOString } from "./utils";

// Get cookie by name
export const getCookie = (name) => {
  const match = document.cookie.match(new RegExp("(^| )" + name + "=([^;]+)"));
  return match ? match[2] : null;
};

// Get HubSpot cookie
export const getHubspotUTK = () => {
  return getCookie("hubspotutk");
};

// Extract UTM params from URL
export const getUTMParams = () => {
  const params = new URLSearchParams(window.location.search);

  return {
    utmSource: params.get("utm_source") || "",
    utmMedium: params.get("utm_medium") || "",
    utmCampaign: params.get("utm_campaign") || "",
    utmTerm: params.get("utm_term") || "",
    utmContent: params.get("utm_content") || "",
    utmMarket: params.get("utm_market") || ""
  };
};

// Store UTM params (call once on app load)
export const storeUTMParams = () => {
  const utm = getUTMParams();

  // Only store if at least one value exists
  if (Object.values(utm).some(Boolean)) {
    localStorage.setItem("utmData", JSON.stringify(utm));
  }
};

// Get stored UTM params
export const getStoredUTMParams = () => {
  return JSON.parse(localStorage.getItem("utmData")) || {};
};

// Build utmHistory payload
export const buildUtmHistory = () => {
  const stored = getStoredUTMParams();

  return [
    {
      utmSource: stored.utmSource || "",
      utmMedium: stored.utmMedium || "",
      utmCampaign: stored.utmCampaign || "",
      utmTerm: stored.utmTerm || "",
      utmContent: stored.utmContent || "",
      utmMarket: stored.utmMarket || "",
      visitTime: getAucklandISOString()
    }
  ];
};
